// Enums that are NOT exposed in the GraphQL schema but are imported from
// `'../graphql'` by frontend code at runtime. Kept here (not in enums.ts)
// because enums.ts is overwritten by `npm run codegen` in backend-workspace.
//
// Backend's canonical definition lives in
// backend-workspace/apps/gripp-api/src/shared/dateUtils.ts with ALL-CAPS
// member names. The frontend has historically used PascalCase keys (the
// codegen transform style), so this file preserves the PascalCase shape that
// existing call sites expect.

export enum DayIntervalUnit {
  Minutes = 'MINUTES',
  Hours = 'HOURS',
  Days = 'DAYS',
  Weeks = 'WEEKS',
  Months = 'MONTHS',
}
